import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';

const ChordProRenderOptionsModal = ({ show, onHide, onConfirm }) => {
    const [options, setOptions] = useState({
        transpose: 0,
        lyricsOnly: false,
        noChordGrids: false,
    });

    useEffect(() => {
        // Reset state when modal is shown
        if (show) {
            setOptions({
                transpose: 0,
                lyricsOnly: false,
                noChordGrids: false,
            });
        }
    }, [show]);

    const handleConfirm = () => {
        onConfirm(options);
        onHide();
    };

    const handleOptionChange = (e) => {
        const { name, checked } = e.target;
        setOptions(prev => ({
            ...prev,
            [name]: checked,
        }));
    };

    const increment = () => setOptions(prev => ({ ...prev, transpose: prev.transpose + 1 }));
    const decrement = () => setOptions(prev => ({ ...prev, transpose: prev.transpose - 1 }));

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Настройки генерации PDF</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Транспонирование</Form.Label>
                    <InputGroup>
                        <Button variant="outline-secondary" onClick={decrement}>-</Button>
                        <Form.Control
                            type="number"
                            name="transpose"
                            value={options.transpose}
                            readOnly
                            className="text-center"
                        />
                        <Button variant="outline-secondary" onClick={increment}>+</Button>
                    </InputGroup>
                </Form.Group>
                <hr />
                <Form.Group>
                    <Form.Check 
                        type="switch"
                        id="lyrics-only-switch"
                        label="Только текст (без аккордов)"
                        name="lyricsOnly"
                        checked={options.lyricsOnly}
                        onChange={handleOptionChange}
                    />
                </Form.Group>
                <Form.Group className="mt-2">
                    <Form.Check 
                        type="switch"
                        id="no-chord-grids-switch"
                        label="Не показывать схемы аккордов"
                        name="noChordGrids"
                        checked={options.noChordGrids}
                        onChange={handleOptionChange}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleConfirm} className="w-100">
                    Сгенерировать PDF
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChordProRenderOptionsModal;
